import React from 'react';
import { View } from 'react-native';
//= ========================================================================

const LongLine = ({
  globJSON,
  width,
  marginBottom,
}) => (
  <View
    style={{
      width,
      height: 1,
      backgroundColor: globJSON.configurations.theme.colors.border_light_color,
      marginBottom,
    }}
  />
);
export default LongLine;
